<div class="ds-grid ds-grid--2">
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single Item</h3>
			<p class="ds-example__header-subtitle">Only the current page</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-breadcrumbs [breadcrumbItems]="singleItem"></eif-custom-breadcrumbs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Two Levels</h3>
			<p class="ds-example__header-subtitle">One link followed by the active item</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-breadcrumbs [breadcrumbItems]="twoLevels"></eif-custom-breadcrumbs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Three Levels</h3>
			<p class="ds-example__header-subtitle">Links with a string route; the last item is always the active one</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-breadcrumbs [breadcrumbItems]="threeLevels"></eif-custom-breadcrumbs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Array Routes</h3>
			<p class="ds-example__header-subtitle">route accepts a string or a router commands array</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-breadcrumbs [breadcrumbItems]="arrayRoutes"></eif-custom-breadcrumbs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Without Routes</h3>
			<p class="ds-example__header-subtitle">Items without a route render as plain text, even if not last</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-breadcrumbs [breadcrumbItems]="withoutRoutes"></eif-custom-breadcrumbs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Deep Hierarchy</h3>
			<p class="ds-example__header-subtitle">Many levels of navigation</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-breadcrumbs [breadcrumbItems]="deepHierarchy"></eif-custom-breadcrumbs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Long Labels</h3>
			<p class="ds-example__header-subtitle">Behavior with lengthy labels</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-breadcrumbs [breadcrumbItems]="longLabels"></eif-custom-breadcrumbs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Empty</h3>
			<p class="ds-example__header-subtitle">No items renders an empty list</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-breadcrumbs [breadcrumbItems]="[]"></eif-custom-breadcrumbs>
		</div>
	</div>
</div>
